import { render, staticRenderFns } from "./DeleteSettingDialog.vue?vue&type=template&id=5585620c&"
import script from "./DeleteSettingDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteSettingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports